export default __webpack_public_path__ + "static/media/lingk.14d17906.png";